import React from 'react';
import PropTypes from 'prop-types';
export const SelectedAndTotal = ({ selectedRecords, totalRecords, type }, { t }) => {
  let stingToBeDisplayed = '';
  switch (type) {
    case 'sessions':
      stingToBeDisplayed = t('sessions.selectedAndTotal', { selectedRecords, totalRecords });
      break;
    case 'webinars':
      stingToBeDisplayed = t('webinars.selectedAndTotal', { selectedRecords, totalRecords });
      break;
    case 'recordings':
      stingToBeDisplayed = t('recordings.selectedAndTotal', { selectedRecords, totalRecords });
      break;
    default:
      break;
  }
  return <div className="selectedAndTotalComponent">{stingToBeDisplayed}</div>;
};
SelectedAndTotal.contextTypes = {
  t: PropTypes.func.isRequired
};
SelectedAndTotal.propTypes = {
  selectedRecords: PropTypes.number.isRequired,
  totalRecords: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/Components/SelectedAndTotal/SelectedAndTotal.js